<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">If You Wake<br/> at Midnight</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/text/ch004#acknowledgement">Acknowledgement</a></li>
<li id="toc-li-5"><a href="#/text/ch005#preface">Preface</a></li>
<li id="toc-li-6"><a href="#/text/ch006#chapter-1">Chapter 1: Taken on Trust</a><ol class="toc"><li id="toc-li-7"><a href="#/text/ch006#taken-on-trust"></a></li>
</ol></li>
<li id="toc-li-8"><a href="#/text/ch007#chapter-2">Chapter 2: Of Mice and Men</a><ol class="toc"><li id="toc-li-9"><a href="#/text/ch007#of-mice-and-men"></a></li>
</ol></li>
<li id="toc-li-10"><a href="#/text/ch008#chapter-3">Chapter 3: Joining the Dots</a><ol class="toc"><li id="toc-li-11"><a href="#/text/ch008#joining-the-dots"></a></li>
</ol></li>
<li id="toc-li-12"><span href="#/text/ch009#chapter-4" title="Link target outside of Sample">Chapter 4: Bydand</span><ol class="toc"><li id="toc-li-13"><span href="#/text/ch009#bydand" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-14"><span href="#/text/ch010#chapter-5" title="Link target outside of Sample">Chapter 5: Swerve to Lead</span><ol class="toc"><li id="toc-li-15"><span href="#/text/ch010#swerve-to-lead" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-16"><span href="#/text/ch011#chapter-6" title="Link target outside of Sample">Chapter 6: On Se Leve!</span><ol class="toc"><li id="toc-li-17"><span href="#/text/ch011#on-se-leve" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-18"><span href="#/text/ch012#chapter-7" title="Link target outside of Sample">Chapter 7: Them That Ask No Questions</span><ol class="toc"><li id="toc-li-19"><span href="#/text/ch012#them-that-ask-no-questions" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-20"><span href="#/text/ch013#chapter-8" title="Link target outside of Sample">Chapter 8: See How Dumb They Lie</span><ol class="toc"><li id="toc-li-21"><span href="#/text/ch013#see-how-dumb-they-lie" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-22"><span href="#/text/ch014#chapter-9" title="Link target outside of Sample">Chapter 9: Anatomy of Suicide</span><ol class="toc"><li id="toc-li-23"><span href="#/text/ch014#anatomy-of-suicide" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-24"><span href="#/text/ch015#chapter-10" title="Link target outside of Sample">Chapter 10: Not an Interested Person</span><ol class="toc"><li id="toc-li-25"><span href="#/text/ch015#not-an-interested-person" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-26"><span href="#/text/ch016#chapter-11" title="Link target outside of Sample">Chapter 11: Picking Up the Pieces</span><ol class="toc"><li id="toc-li-27"><span href="#/text/ch016#picking-up-the-pieces" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-28"><span href="#/text/ch017#chapter-12" title="Link target outside of Sample">Chapter 12: Coming Out of the Fog</span><ol class="toc"><li id="toc-li-29"><span href="#/text/ch017#coming-out-of-the-fog" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-30"><span href="#/text/ch018#chapter-notes" title="Link target outside of Sample">Chapter Notes</span></li>
<li id="toc-li-31"><span href="#/text/ch019#bibliography" title="Link target outside of Sample">Bibliography</span></li>
<li id="toc-li-32"><span href="#/text/ch020#appendix-1" title="Link target outside of Sample">Appendix-1</span></li>
<li id="toc-li-33"><span href="#/text/ch021#appendix-2" title="Link target outside of Sample">Appendix-2</span></li>
<li id="toc-li-34"><span href="#/text/ch022#appendix-3" title="Link target outside of Sample">Appendix-3</span></li>
<li id="toc-li-35"><span href="#/text/ch023#appendix-4" title="Link target outside of Sample">Appendix 4</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?01e0132a